<template>
    <div v-click-outside="handleClickOutside" class="d-flex flex-column justify-content-center position-relative">
        <span v-b-tooltip.hover :title="title">
            <IconButton
                :icon="icon"
                :disabled="disabled"
                variant="outline-primary"
                class="my-1 d-flex justify-content-center align-items-center"
                @click="toggleMenu"
            />
        </span>
        <div v-show="isOpen" class="position-absolute pb-4">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconButton from '../../stories/components/buttons/IconButton.vue'

export default defineComponent({
    name: 'TableSettingsDropdown',
    components: {
        IconButton,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen
        },
        closeMenu() {
            this.isOpen = false
        },
        handleClickOutside() {
            this.closeMenu()
        },
    },
})
</script>
